
import { mapActions } from 'vuex';
export default {
  methods: {
    ...mapActions({
      closeDialog: 'order/closeDialog',
    }),
    handleClick() {
      this.closeDialog();
      location.reload();
    },
  },
};
